/** Alt text for a content image. Empty labels fall back to the kind alone. */
export function contentImageAlt(label: string | null | undefined, kind: string): string {
  const name = (label ?? '').replace(/\s+/g, ' ').trim();
  const what = kind.trim() || 'image';
  if (!name) return what;
  return `${name} — ${what}`;
}
